import React from 'react';
import '../App.css';

const VideoPopup = ({ videos, releaseId, artist, title, onClose, discogsUrl }) => {
    const hasVideos = videos && videos.length > 0;

    // Convert YouTube URLs to embed format
    const getEmbedUrl = (url) => {
        if (url.includes('youtube.com/watch?v=')) {
            const videoId = url.split('v=')[1]?.split('&')[0];
            return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
        } else if (url.includes('youtu.be/')) {
            const videoId = url.split('youtu.be/')[1]?.split('?')[0];
            return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
        }
        return null;
    };

    return (
        <div className="video-popup-overlay" onClick={onClose}>
            <div className="video-popup-content" onClick={(e) => e.stopPropagation()}>
                <button className="video-popup-close-button" onClick={onClose}>×</button>
                <h2>{artist && title ? `${artist} - ${title}` : title || 'Videos'}</h2>
                {hasVideos ? (
                    <div className="video-popup-videos">
                        {videos.map((video, index) => {
                            const embedUrl = getEmbedUrl(typeof video === 'string' ? video : video.url);
                            if (!embedUrl) return null;
                            return (
                                <div key={index} className="video-popup-video-wrapper">
                                    <iframe
                                        src={embedUrl}
                                        title={`Video ${index + 1}`}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        className="video-popup-iframe"
                                    />
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className="video-popup-no-videos">
                        <p>Wormhole has no videos for this release.</p>
                    </div>
                )}
                {discogsUrl && (
                    <div className="video-popup-discogs-link">
                        <a
                            href={discogsUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="video-popup-discogs-button"
                        >
                            View on Discogs
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};

export default VideoPopup;

